import type { InjectionKey, Ref } from 'vue'
import { computed, inject, provide } from 'vue'

const collapseVisibleKey: InjectionKey<Readonly<Ref<boolean>>> = Symbol('collapse-visible')

export function useCollapseVisible() {
  return inject(collapseVisibleKey, undefined)
}

export function provideCollapseVisible(show: () => boolean) {
  const parentVisible = useCollapseVisible()
  const visible = computed(() => show() && (parentVisible?.value ?? true))

  provide(collapseVisibleKey, visible)
}
